import React from 'react';
import styles from './LooseItemsTableRow.module.scss';

import { StyledTableCell, StyledTableRow } from 'components/StyledComponents';
import LinkComponent from 'components/LinkComponent/LinkComponent';

import { USER_DETAILED_PATH } from 'constants/routeConstants';

import { getUserFullName, joinWithComma, pluck } from 'helpers/AppHelpers';
import { NON_DRAT_USER_NAME } from '../../../helpers';

import { IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import CreateIcon from '@material-ui/icons/Create';

export default function LooseItemsTableRow({ row, onRemove, onEdit }) {
  return (
    <StyledTableRow className={styles.tableRow}>
      <StyledTableCell className={styles.nameCell}>
        {row?.firstName ? (
          <LinkComponent path={`${USER_DETAILED_PATH}/${row?.id}`} name={getUserFullName(row)} />
        ) : (
          NON_DRAT_USER_NAME
        )}
      </StyledTableCell>
      <StyledTableCell className={styles.emailCell}>{row?.email || ''}</StyledTableCell>
      <StyledTableCell className={styles.roleCell}>{row?.userRole?.role || ''}</StyledTableCell>

      <StyledTableCell className={styles.baaRecipientCell}>
        {row?.isBAARecipient ? 'Yes' : 'No'}
      </StyledTableCell>
      <StyledTableCell className={styles.approveRecipientCell}>
        {row?.isLooseItemApproveRecipient ? 'Yes' : 'No'}
      </StyledTableCell>
      <StyledTableCell className={styles.locationCell}>
        {row?.isSelectedAllLocations
          ? 'All Selected'
          : joinWithComma(pluck(row?.locations || [], 'siteCode'))}
      </StyledTableCell>
      <StyledTableCell className={styles.locationCell}>
        {row?.isSelectedAllVerificationRecipientLocations
          ? 'All Selected'
          : joinWithComma(pluck(row?.verificationLocations || [], 'siteCode'))}
      </StyledTableCell>

      <StyledTableCell className={styles.editCell}>
        <div className={styles.controls}>
          <IconButton className={styles.icon_button} onClick={() => onEdit(row)}>
            <CreateIcon />
          </IconButton>
          <IconButton className={styles.icon_button} onClick={() => onRemove(row.id)}>
            <DeleteIcon />
          </IconButton>
        </div>
      </StyledTableCell>
    </StyledTableRow>
  );
}
